export const en = {
    //#region common
    default: {
        search: 'SEARCH',
        confirm: 'CONFIRM',
        register: 'REGISTER',
        continue: 'Continue',
        day: 'Day',
        month: 'Month',
        year: 'Year',
        birthdate: 'Date of Birth',
        nointerner_1: 'No internet connection',
        nointerner_2: 'Check your network settings and try again'
    },
    date: {
        days: 'day',
        months: 'month',
        years: 'year',
        minutes: 'minute',
        minutes_short: 'min',
        minutes_short2: 'Minutes',
        hours: 'hour',
        hours_short: 'hr',
        date_flase: 'Please select your birthday.',
        month_full: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        month_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        month_full_arr: [{ strvalue: "01", strtext: 'January' },
        { strvalue: '02', strtext: 'February' },
        { strvalue: '03', strtext: 'March' },
        { strvalue: '04', strtext: 'April' },
        { strvalue: '05', strtext: 'May' },
        { strvalue: '06', strtext: 'June' },
        { strvalue: '07', strtext: 'July' },
        { strvalue: '08', strtext: 'August' },
        { strvalue: '09', strtext: 'September' },
        { strvalue: '10', strtext: 'October' },
        { strvalue: '11', strtext: 'November' },
        { strvalue: '12', strtext: 'December' }]
    },
    redeem_button: {
        default: 'REDEEM NOW',
        default_freegift: 'REDEEM NOW',
        none: '',
        soldOut: 'THIS EVENT IS FULLY RESERVE',
        soldOut_freegift: 'FULLY RESERVE',
        soldOutBuy: 'This reward is not available',
        maxPerPerson: 'You are no longer eligible',
        maxPerPerson_freegift: 'CAMPAIGN EXPIRED',
        redeemCoolDown: 'You have reached the redemption limit',
        nextDate: '<br/>at : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'This campaign requires user action before redemption, please review the conditions first.',
        campaignExpired: 'CAMPAIGN EXPIRED',
        campaignExpiredBuy: 'Campaign has expired',
        campaignNotAvailable: 'Sorry. This reward is not available',
        campaignNotAvailableBuy: 'Sorry. This product is not available',
        notEnoughPoint: 'Your points are not enough to redeem this gift.',
        notSupport: 'This campaign is not support.',
        soldOutBooking: 'Sorry, The selected time is fully booked.',
        alreadyRedeem: 'You have already booked for the event.',
        longerEligible: 'You cannot select a time that has already been selected.',
        error101: 'No booking is allow at provided counter.',
        error102: 'BC or room is not available.',
        error103: 'BC is not allowed to handle that service.',
        error104: 'Sorry, The selected time is fully booked.',
        error105: 'You have already booked for the event.',
        error108: 'You have reached free cabin service limit.',
        error109: 'Service is not available at the counter on the date.',
        error201: 'Class is full.',
        error301: 'Please contact Call Center 02-666-9496.',
        error999: 'System error.',

        cate:{
            error102: 'The service is unavailable at your selected time.',
            error105: 'You already have another booking at the same time.',
            error106: 'You have already booked for this service.',
            error108: 'You have fully redeemed your quotas.',
            error202: 'You have already booked for this service.',
            error301: 'Please contact Dior Customer Service at 02-666-9496 during business hours.',
            error999: 'System error. Please try again.',
        }
    },
    confirm_redeem: {
        confirm: "Confirm cancel",
        cancel: "Not now",

        confirm2: "Confirm",
        cancel2: "Cancel",

        default1: "You are redeeming this reward with",
        default2: "points.",

        headline: 'PICK-UP POINT',
        headline2: 'Please select your pick-up store.',
        free: 'Serial will available for {0} after confirm',
        free_no_timer: 'Confirm to redeem',
        free_delivery: 'Please enter shipping information to redeem',
        draw: 'Confirm to join campaign <br/> Winner will be announced after {0}',
        draw_delivery: 'Please enter shipping information to redeem',
        deal: 'Serial will available for {0} after confirm',
        deal_no_timer: 'Confirm to redeem',
        deal_delivery: 'Please enter shipping information to redeem',
        buy: 'Confirm to purchase',
        buy_delivery: 'Please enter shipping information to buy',
        interface: 'This will redirect to website after confirm',
        reward_confirm: 'Confirm your reservation for',
        freegift_confirm: "PRIVILEGE CONFIRMATION",
        freegift_confirm_message: 'Do you want to confirm redeem',
        pleasefill: 'Please fill information',
        continue: 'Continue',
        province: 'Province',
        district: 'District',
        brance: 'Store',

        headline_store: 'SELECT DATE & TIME',
        headline_store2: 'Please choose the store </br> to pick up your product.',
        store: 'Branch',
        date: 'Date',
        datetime:'Time',
        book: 'BOOK',
        news_from: 'Where did you get the information',
        select_one: 'Please select',
        answer_one: 'Please specify (Example Punpro Central)',
        question_mark: '?',
        bcs: 'BCs',
        select_store: 'BOOKING DETAILS',
        please_choose: 'Please select your preferred </br> branch for the service.',
        not_time: 'not available time',

        select_freegift_store: "Please choose Dior counter </br> where you will pick up your gift.",
        select_placeholder: "Branch",

    },
    gift_detail: {
        confirm: "Confirm",
        cancel: "Cancel",

        header: 'SELECT PICK-UP LOCATION',
        header2: 'Please choose Dior counter <br/> where you will pick up your gift.',
        province: 'Province',
        district: 'District',
        brance: 'Branch',

        pleasefill: 'Please fill information',
        thank_redeem: 'THANK YOU FOR YOUR CONFIRMATION',
        thank_redeem_freegift: 'THANK YOU FOR YOUR CONFIRMATION',
        close: 'Close',
        use_code_now: "CODE SHOW",
        mark_use: "MARK AS USE",
        confirm_redeem: {

            header: 'GIFT RESERVATION',
            header2: 'Do you want to confirm redeem',
            name: 'Name : ',
            member_id:'Member ID : ',
            branch: 'Branch : ',
            gift: 'Gift : ',
            use: 'Use : ',
            accept: 'Accept ',
            condition: 'Conditions ',
            order_no: 'Order No. : ',
        },

        error101: 'Incorrect member code',
        error102: 'Member code is suspended',
        error103: 'Member cardlog not found',
        error104: 'Gift Reservation is not allowed for this Member Type',
        error201: 'No gift redemption list',
        error202: 'Bonus Point insufficient',
        error203: 'Redemption date after grace period date',
        error204: 'Invalid collection counter code',
        error205: 'Courier delivery is not allowed',
        error206: 'Incomplete delivery address',
        error207: 'Invalid email address for gift notification',
        error208: 'Violate Gift Reservation Validation Module',
        error300: 'Gift item error',
        error999: 'Other error',
        error301: 'Invalid gift',
        error302: 'No stock for gift',
        error303: 'Redemption gift bonus point is not positive',
        error304: 'Gift reservation quota within membership period exceeded',
        error305: 'Invalid gift item type',
        error306: 'Invalid redemption channel',
        error307: 'Gift item code is not allowed for this Member Type',
    },
    purchase: {
        show_code: 'View code',
        cancel_book: 'Booking Cancellation',
        canceled_book: 'Cancelled',
        code_expired: 'Expired',

        delivery: 'Product will be mailed based on Campaign Condition.',
        shipped: 'The Product has been delivered.',
        parcel_no: 'ParcelNo',

        not_draw1: 'Not yet drawn,',
        not_draw2: 'please check back at a later date',
        draw_winner1: 'You are the winner',
        draw_winner2: '',
        draw_not_win1: 'Sorry you are not the winner,',
        draw_not_win2: 'better luck next',
        Used: "USED",
    },
    serial: {
        close_btn: 'Close',
        show_code_at_shop: 'Please show code below to claim your privilege.',

        delivery: 'Product will be mailed based on Campaign Condition.',

        draw: 'Thank you for joining us.<br/>Winner will be announced after {0}',
        draw_after: 'after',

        qr_code: 'QR Code',
        barcode: 'Barcode',
        code: 'Code',

        expire_in: 'Expire in ',
        code_expired: 'This serial has expired.',

        redeem_on: 'Redeem on {0}',
        headBooking: 'Please show this screen upon your arrival for the booked.',
        show_code_freegift: 'Please present this code at Dior counter.',

        show_code: 'Please present this code at Dior counter.',
        order_no: 'Order No. : ',
        name: 'Name : ',
        member_id: 'Member ID : ',
        branch: 'Branch : ',
        Use: 'Use : ',
        Used: "USED",
    },
    //#endregion common

    //#region shipping
    shipping: {
        headline: 'Shipping address',

        firstname: {
            name: 'Firstname',
            placeholder: 'Firstname',
            required: 'Please enter firstname',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'Lastname',
            placeholder: 'Lastname',
            required: 'Please enter lastname',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'Address',
            placeholder: 'Address',
            required: 'Please enter address',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'Contact number',
            placeholder: 'Contact number',
            required: 'Contact number',
            too_short: 'Contact number must be {0} digits',
            invalid: 'Incorrect contact number format',
        },
        nationalid: {
            name: 'National id',
            placeholder: 'National id',
            required: 'Please enter national id',
            too_short: 'National id number must be {0} digits',
            invalid: 'Incorrect national id format',
        },
        email: {
            name: 'Email',
            placeholder: 'Email',
            required: 'Please enter email address',
            too_short: '',
            invalid: 'Incorrect email format',
        },
        zipcode: {
            name: 'Zipcode',
            placeholder: 'Zipcode',
            required: 'Please enter zipcode',
            too_short: 'Zipcode must be {0} digits',
            invalid: 'Invalid zipcode',
        },
        subdistrict: {
            name: 'Sub-district',
            placeholder: 'Sub-district',
            required: 'Please selece sub-district',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'District',
            placeholder: 'District',
            required: 'Please selece district',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'Province',
            placeholder: 'Province',
            required: 'Please selece province',
            too_short: '',
            invalid: '',
        },

        save_address: 'Save address for next privilege',
        save_address_buy: 'Save address for next puchase',

        confirm_btn: 'Confirm',
        cancel_btn: 'Cancel',

        alert_headline: 'Shipping address',
        alert_ok_btn: 'OK',

        thank_header: 'YOUR GIFT RESERVATION IS COMPLETED',
        text_thank: 'You will be notified once the gift is available at your selected pick-up store',
        close: 'Close'
    },
    //#endregion shipping

    //#region page
    main: {
        home_page: "Home",
        login: "Login",
        campaign: "Campaign",
        category: 'Category',
        map: "Map",
        history: 'History',
        profile: "Profile",
        logout: "Logout",
        lang: "Language",
        msgLogout: "Logout ?",
        cancel: "Cancel",
        makeup: "MAKEUP",

    },
    campaign: {
        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use : ',
    },
    detail: {
        detail: 'Detail',
        condition: 'Conditions',
        free: 'Free of charge',

        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use : ',
        available_date: 'Date',
        booking_now: 'BOOK NOW',
        color: {
            name: 'Color',
            placeholder: 'Please select color',
            required: 'Please select color',
        },
        size: {
            name: 'Size',
            placeholder: 'Please select size',
            required: 'Please select size',
        },
    },
    history: {
        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',

        parcel_number: 'Parcel No. : ',
        date: 'Date : ',
        time: 'Time : ',
        status: 'Status : ',
        brance: 'Branch : ',
        bcs: 'BCs : ',

        gift_status : {
            gc: "Cancelled",
            gd: "In Delivery",
            ge: "Expired",
            gf: "Confirmed",
            gi: "Reserved",
            gr: "Redeemed",
            gt: "Ready to pick",
            go: "Order Processing",
        },
        head_cancel: 'Redeem Cancellation',
        head_cancel2: 'Do you want to cancel Reservation',
        title_cancel: 'Your redemption has been successfully canceled.'
    },
    cancel_booking: {

        header: 'Redeem Cancellation',
        head2: 'Do you want to cancel the booking',

        head_cancel: 'Booking Cancellation',
        head_cancel2: 'You booking has been cancelled.',

        booking_no: 'Booking No. : ',
        name: 'Name : ',
        member_id:'Member ID : ',
        date: 'Date : ',
        time: 'Time : ',
        branch: 'Branch : ',
        bcs: 'BCs : ',
    },
    home: {
        title: 'Register for Dior\'s membership',
        enjoy_privilege: 'Privileges for Dior\'s members',
        product_info: 'Product information',
        special_event: 'Special Events',
        gift: 'Gifts for you',
        continue: 'Continue',
    },
    //#endregion page

    //#region register
    register: {
        registeration: 'REGISTRATION',
        birthday: 'Date of Birth',
        phone_number: 'Phone Number',
        or: 'or',
        click_to_scan: 'Click to scan the QR code shown at Dior Counter',
        scan_qr_code: 'Scan QR code',
        register_term: 'I argee to Dior\'s <u>terms and conditions</u>',
        mobile_number_validate: 'PHONE NUMBER VERIFICATION',
        send_otp_msg: 'An OTP was sent to verify your phone number.',
        please_enter_otp: 'Please enter OTP',
        enter_otp: 'Enter OTP',
        refcode: 'Reference Code : ',
        resend_otp: 'Resend OTP in…',
        form_register_title: 'MEMBERSHIP APPLICATION FORM',
        register_completed: 'REGISTRATION<br>COMPLETED',
        welcome_to_dior: 'Welcome to Dior',
        register_not_complete: 'REGISTRATION<br> NOT SUCCESSFUL',
        try_again: 'Please try again',

        contactnumber: {
            name: 'Phone Number',
            placeholder: 'Phone Number',
            // required: 'กรุณาใส่เบอร์โทร',
            required: 'Please enter the information',
            too_short: 'Please provide 10-digit phone number',
            invalid: 'Format number incorrect',
        },
        otp: {
            name: '',
            placeholder: 'Enter OTP',
            required: 'Please enter the OTP',
            too_short: 'The OTP is invalid',
            invalid: '',
            notcorrect: 'Please try again',
            otpexpire: 'Your OTP expires'
        },
        firstname: {
            name: 'First Name',
            placeholder: 'First Name',
            required: 'Please enter your first name',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'Last Name',
            placeholder: 'Last Name',
            required: 'Please enter your last name',
            too_short: '',
            invalid: '',
        },
        birthdate: {
            required: 'Please enter your birth year',
            invalid: 'กรุณาใส่วันเกิดให้ถูกต้อง',
            pleasefill: 'Please enter the information',
        },
        email: {
            name: 'Email Address',
            placeholder: 'Email Address',
            required: '',
            too_short: '',
            invalid: '',
        },
        address: {
            name: 'Address',
            placeholder: 'Address (Optional)',
            required: '',
            too_short: '',
            invalid: '',
        },
        zipcode: {
            name: 'Zip Code',
            placeholder: 'Zip Code',
            required: '',
            too_short: '',
            invalid: 'Zip Code invalid',
        },
        province: {
            name: 'Province',
            placeholder: 'Province',
            required: '',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'District',
            placeholder: 'District',
            required: '',
            too_short: '',
            invalid: '',
        },
        subDistrict: {
            name: 'Sub-district',
            placeholder: 'Sub-district',
            required: '',
            too_short: '',
            invalid: '',
        },
        agree:{
            name: "I agree to Dior's",
            placeholder: "I agree to Dior's",
        },
        term:{
            name: "terms and conditions",
            placeholder: "terms and conditions",
            required: 'I agree to Dior\'s terms, conditions and privacy policy',
        },
        ms: "MS.",
        mrs: "MRS.",
        mr: "MR.",
    },
    //#endregion register
    profile: {
        title: 'MY PROFILE',
        edit: 'Edit',
        mycode: 'My membership ID',
        mypoint: 'My Points',
        become_member: "Become a member of",
        upgrade_to: "Upgrade to ",
        maintain: "Maintain to ",
        spent: "Spend",
        baht: "baht",
        purchased: "purchase",
        time: "times",
        member_exp: "points and status expiring : ",
        white: "WHITE",
        silver: "SILVER",
        gold: "GOLD",
        platinum: "PLATINUM",
        hight_level: "Highest Status",
        my_status: "MY STATUS",
        and: "and",
        more_to: "more to level up your membership status.",
        more_to_plat: "more to maintain status",
    },
    //#region edit profile
    editprofile: {
        title: 'EDIT MY PROFILE',
        continue: 'Continue',
        firstname: {
            name: 'Firstname',
            placeholder: 'Firstname',
            required: 'Please enter firstname',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'Lastname',
            placeholder: 'Lastname',
            required: 'Please enter lastname',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'Address',
            placeholder: 'Address',
            required: 'Please enter address',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'Phone Number',
            placeholder: 'Phone Number',
            required: 'Phone Number',
            too_short: 'Phone Number must be {0} digits',
            invalid: 'Incorrect Phone Number format',
        },
        nationalid: {
            name: 'National id',
            placeholder: 'National id',
            required: 'Please enter national id',
            too_short: 'National id number must be {0} digits',
            invalid: 'Incorrect national id format',
        },
        email: {
            name: 'Email',
            placeholder: 'Email',
            required: 'Please enter email address',
            too_short: '',
            invalid: 'Incorrect email format',
        },
        zipcode: {
            name: 'Zipcode',
            placeholder: 'Zipcode',
            required: 'Please enter zipcode',
            too_short: 'Zipcode must be {0} digits',
            invalid: 'Invalid zipcode',
        },
        subdistrict: {
            name: 'Sub-district',
            placeholder: 'Please selece sub-district',
            required: 'Please selece sub-district',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'District',
            placeholder: 'Please selece district',
            required: 'Please selece district',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'Province',
            placeholder: 'Please selece province',
            required: 'Please selece province',
            too_short: '',
            invalid: '',
        },
        ms: "MS.",
        mrs: "MRS.",
        mr: "MR.",
    },
    //#endregion edit profile
    reward: {
        special_event: 'SERVICE LIST',
        redeem_history: 'MY BOOKINGS',
        name: 'DIOR REWARDS',
        point: 'POINT',
        expired_date: 'Expired on :',
        free_gift_list: 'PRIVILEGE',
        gift_list: 'GIFT LIST',
        gift_list_history: 'PRIVILEGE </br> HISTORY',
        history: 'REDEMPTION </br> HISTORY'
    },
    location: {
        nearby: '10-km radius',
        btnView: 'More details',
        address: 'Address:',
        operation: 'Operating hours:',
        phone: 'Phone number:',
        km: 'km.'
    },
    error_connect: {
        message: 'No internet connection.<br/> Check your network settings <br/> and try again',
        btn_close: 'CLOSE'
    },

    error_empty: {
        message: "Incomplete information, Please contact Customer Services by calling 02-716-1815 (Mon-Fri , 09.00 am – 04.00 pm)"
    },

    cancel_membership: {
        message: 'Please contact the Client Service Center',
        phone: 'Phone: (+66) 02-666-9462',
        email: 'Email: contact@dior.co.th'
    },

    contact_us: {
        title: 'For Parfums Christian Dior customer enquiries',
        hotlineLabel: 'Customer Service Hotline',
        emailLabel: 'Customer Service Email',
        onlineContactLabel: 'Online Contact Form',
        hoursLabel: 'Hours',
        hotline: '(+66) 02-666-9462',
        email: ' contact@dior.co.th',
        onlineContact: 'https://shop.dior.co.th/pages/contact-us',
        hours: '10:00am – 12:00pm; 2:00pm – 6:00pm',
        days: 'Monday to Friday excluding Saturday, Sunday and Public Holidays'
    }
};
